module.exports = __webpack_public_path__ + "img/chanceofrain.8bdf47fe.png";